export const CheckBoxListRightContentName = 'checkBoxListRightContentComponent';
